<template>
  <v-container fluid class="pa-0 ma-8">
    <v-btn @click="send4Cut" class="ma-1" rounded="xl">أرسل للقطع</v-btn>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="messages"
      :sort-by="[{ key: 'name', order: 'asc' }]"
      class="elevation-1"
    >
      <template v-slot:no-data>
        <h3>No data available</h3>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>رسائل النظام</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <DialogMessageNew
            :users="filteredUsers"
            :saveFunction="saveMessage"
            iconName="mdi-plus"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <DialogMessageShow :item="item" iconName="mdi-update" />
        </v-row>
      </template>
      <template v-slot:[`item.sender_id`]="{ item }">
        <v-container>
          <p>{{ item.sender.fullname }}</p>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
  <overlay-loader v-model="loading" />
</template>
<script>
import DialogMessageNew from "@/components/dialogs/DialogMessageNew.vue";
import DialogMessageShow from "@/components/dialogs/DialogMessageShow.vue";

import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";

export default {
  components: {
    DialogMessageNew,
    DialogMessageShow,
    OverlayLoader,
  },
  data: () => ({
    loading: false,
    headers: [
      { title: "المرسل", key: "sender_id" },
      { title: "النص", key: "text" },
      { title: "العمليات", key: "actions" },
    ],
    dialog: false,
    dialogSimp: false,
    editedIndex: -1,
    // messages: {
    //   delete: "هل أنت متأكد",
    // },
    // customer_id: -1,
  }),
  computed: {
    messages() {
      return repo.messages.getAllMessages();
    },

    users() {
      return repo.users.getAllUsers();
    },
    filteredUsers() {
      //todo: filter to get only the accountants and observers
      return this.users;
    },
  },
  methods: {
    async send4Cut() {
      const res = await repo.messages.send4Cut();
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
    },
    async fetch() {
      this.loading = true;
      const res = await repo.messages.fetchAll();
      const res2 = await repo.users.fetchAll();
      if (res && res2) {
        //swalFun.success("success");
        //console.log(res2);
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
    async saveMessage(formData) {
      console.log("form before", formData);
      const res = await repo.messages.addMessage(formData);
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
    },
    async readMessage(id) {
      const res = await repo.messages.readMessage(id);
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
